<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="showDataExclusionWindow"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      top="5%"
      @close="closeDataExclusion"
    >
      <el-form
        ref="dataExclusionRef"
        label-position="top"
        size="small"
        :model="formData"
      >
        <!--车签号-->
        <div v-if="stepType === 1">
          <el-form-item
            :label="$t('mdfeTranslate.SelectTheVTagType')"
            prop="vTagType"
            :rules="{ required: true, message: $t('placeOrder.pleaseChoose'), trigger: ['blur','change'] }"
          >
            <el-radio-group v-model="formData.vTagType" @change="vTagTypeChange">
              <el-radio label="COLLECT">{{ $t('mdfeTranslate.Coleta') }}</el-radio><!--揽收-->
              <el-radio label="DELIVERY">{{ $t('mdfeTranslate.Entrega') }}</el-radio><!--派送-->
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('mdfeTranslate.PleaseEnterVTagKey')" prop="vTagNum">
            <el-input v-model.trim="formData.vTagNum" :placeholder="$t('placeOrder.pleaseInput')">
              <template slot="append">
                <i class="el-icon-circle-plus-outline" style="font-size: 26px" @click="appendTag" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('mdfeTranslate.SelectedVTagQueue')"
            prop="vTagNumList"
          >
            <div style="height: 200px;overflow-y: auto;border: 1px solid #c0c4cc;border-radius: 5px">
              <div
                v-for="(item, index) in formData.vTagNumList"
                :key="index"
                style="border: 1px solid #c0c4cc;border-radius: 3px;margin: 5px;padding: 0 10px"
              >
                {{ item }}
                <el-button
                  type="text"
                  style="float: right;padding: 5px 0"
                  @click="removeVTagNum(index)"
                >
                  <i class="el-icon-delete" style="font-size: 20px;color:#f00;" />
                </el-button>
              </div>
            </div>
          </el-form-item>
        </div>
        <!--mdfe秘钥-->
        <div v-if="stepType === 2">
          <el-form-item :label="$t('mdfeTranslate.PleaseEnterMdfeKey')" prop="mdfeKey">
            <el-input v-model.trim="formData.mdfeKey" :placeholder="$t('placeOrder.pleaseInput')">
              <template slot="append">
                <i class="el-icon-circle-plus-outline" style="font-size: 26px" @click="appendMdfe" />
              </template>
            </el-input>
          </el-form-item>
          <el-form-item
            :label="$t('mdfeTranslate.SelectedMdfeQueue')"
            prop="mdfeKeyList"
          >
            <div style="height: 200px;overflow-y: auto;border: 1px solid #c0c4cc;border-radius: 5px">
              <div
                v-for="(item, index) in formData.mdfeKeyList"
                :key="index"
                style="border: 1px solid #c0c4cc;border-radius: 3px;margin: 5px;padding: 0 10px"
              >
                {{ item }}
                <el-button
                  type="text"
                  style="float: right;padding: 5px 0"
                  @click="removeMdfe(index)"
                >
                  <i class="el-icon-delete" style="font-size: 20px;color:#f00;" />
                </el-button>
              </div>
            </div>
          </el-form-item>
        </div>
        <!--装车重复数据剔除-->
        <div v-if="stepType === 3">
          <el-table
            :data="tableData"
            border
            class="table-height"
            :header-cell-style="{background:'#f2f2f2',color:'black'}"
          >
            <!--车签号-->
            <el-table-column :label="$t('collectionCenter.carNumber')" prop="tags" />
            <!--车签号关联包裹数-->
            <el-table-column :label="$t('mdfeTranslate.CarrierNumberAssociatedWithNumberPackages')" prop="packagesCount" />
            <!--重复包裹数-->
            <el-table-column :label="$t('mdfeTranslate.RepeatPackages')" prop="repeatCount" />
            <!--重复率-->
            <el-table-column :label="$t('mdfeTranslate.RepeatRate')" prop="repeatRate" />
          </el-table>
        </div>
      </el-form>
      <div slot="footer">
        <!--下一步-->
        <el-button
          v-if="stepType !== 3"
          type="primary"
          size="small"
          @click="onNext()"
        >{{ $t('collectionCenter.next') }}</el-button>
        <el-button
          v-if="stepType === 3"
          type="primary"
          size="small"
          @click="confirmDelete"
        >{{ $t('collectionCenter.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { checkTagNumber, getRepeatPackageList, removeRepeatPackage } from '@/api/invoiceCenter';

export default {
  name: 'DataExclusion',
  data() {
    return {
      showDataExclusionWindow: false,
      title: this.$t('mdfeTranslate.VTagsQueue'),
      stepType: 1,
      formData: {
        vTagNum: '',
        mdfeKey: '',
        vTagType: null,
        vTagNumList: [],
        mdfeKeyList: []
      },
      tableData: []
    };
  },
  methods: {
    // 清除输入的数据
    closeDataExclusion() {
      this.formData = {
        vTagNum: '',
        mdfeKey: '',
        vTagType: null,
        vTagNumList: [],
        mdfeKeyList: []
      };
      this.stepType = 1;
      this.tableData = [];
      this.$refs.dataExclusionRef.resetFields();
    },
    // 车签类型改变
    vTagTypeChange() {
      this.formData.vTagNumList = [];
      this.formData.vTagNum = '';
    },
    // 打开数据排除窗口
    openDataExclusion() {
      this.showDataExclusionWindow = true;
    },
    // 添加车签号
    appendTag() {
      if (this.formData.vTagNum) {
        const param = {
          vtag: [this.formData.vTagNum],
          vtagType: this.formData.vTagType
        };
        checkTagNumber(param).then(res => {
          if (res.code === 200) {
            if (this.formData.vTagNumList.includes(this.formData.vTagNum) === false) {
              this.formData.vTagNumList.push(this.formData.vTagNum);
              this.formData.vTagNum = '';
            } else {
              this.$message.error(this.$t('mdfeTranslate.CarrierSignatureRepeated'));
            }
          }
        });
        // if (this.formData.vTagNumList.includes(this.formData.vTagNum) === false) {
        //   this.formData.vTagNumList.push(this.formData.vTagNum);
        //   this.formData.vTagNum = '';
        // } else {
        //   this.$message.error(this.$t('mdfeTranslate.CarrierSignatureRepeated'));
        // }
      } else {
        this.$message.error(this.$t('mdfeTranslate.PleaseEnterTheCarSign'));
      }
    },
    // 删除已选车签号
    removeVTagNum(index) {
      this.formData.vTagNumList.splice(index, 1);
    },
    // 添加mdfe秘钥
    appendMdfe() {
      if (this.formData.mdfeKey) {
        if (this.formData.mdfeKeyList.includes(this.formData.mdfeKey) === false) {
          this.formData.mdfeKeyList.push(this.formData.mdfeKey);
          this.formData.mdfeKey = '';
        } else {
          this.$message.error(this.$t('mdfeTranslate.mdfeKeyRepeat'));
        }
      } else {
        this.$message.error(this.$t('mdfeTranslate.PleaseEnterMdfeKey'));
      }
    },
    // 删除已选mdfe秘钥
    removeMdfe(index) {
      this.formData.mdfeKeyList.splice(index, 1);
    },
    // 下一步
    onNext() {
      this.$refs.dataExclusionRef.validate(valid => {
        if (valid) {
          if (this.stepType === 1) {
            if (this.formData.vTagNumList.length > 0) {
              this.stepType = 2;
              this.title = this.$t('mdfeTranslate.mdfeQueue'); // mdfe秘钥
            } else {
              this.$message.error(this.$t('mdfeTranslate.SelectedVTagQueueCannotBeEmpty'));
            }
          } else if (this.stepType === 2) {
            if (this.formData.mdfeKeyList.length > 0) {
              const param = {
                mdfeKeys: this.formData.mdfeKeyList,
                vtag: this.formData.vTagNumList,
                vtagType: this.formData.vTagType
              };
              getRepeatPackageList(param).then(res => {
                if (res.code === 200) {
                  // res.data.tags = res.data.tags.split(',');
                  // res.data.repeatPackages = res.data.repeatPackages.split(',');
                  this.tableData = res.data;
                  this.stepType = 3;
                  this.title = this.$t('mdfeTranslate.LoadingDataExclusion'); // 装车重复数据剔除
                }
              });
              // this.tableData = [{tags: [4325,6345,6345], packagesCount: 10, repeatCount: 2, repeatRate: '0.2%'}];
              // this.stepType = 3;
              // this.title = this.$t('mdfeTranslate.LoadingDataExclusion'); // 装车重复数据剔除
            } else {
              this.$message.error(this.$t('mdfeTranslate.SelectedMdfeQueueCannotEmpty'));
            }
          }
        }
      });
    },
    // 确定剔除
    confirmDelete() {
      this.$confirm(
        this.$t('mdfeTranslate.PleaseConfirmAgainWhetherExcludeAboveRepeatOrderNumbers'),
        this.$t('collectionCenter.tips'),
        {
          confirmButtonText: this.$t('collectionCenter.confirm'),
          cancelButtonText: this.$t('collectionCenter.cancel'),
          type: 'warning'
        }).then(() => {
        const param = {
          mdfeKeys: this.formData.mdfeKeyList,
          vtag: this.formData.vTagNumList,
          vtagType: this.formData.vTagType
        };
        removeRepeatPackage(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.showDataExclusionWindow = false;
            this.$emit('updateTableData');
          }
        });
      });
    }
  }
};
</script>

<style scoped>

</style>
